import './login.css';

import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { ReactElement, ReactNode } from 'react';
import { BeaconLogo } from '../logo/beacon-logo';

interface LoginWrapperProps {
  children: ReactNode;
}

const LoginWrapper = (props: LoginWrapperProps): ReactElement => {
  return (
    <IonGrid className="login-content ion-no-padding">
      <IonRow
        className={
          'ion-justify-content-center ion-align-items-center login-content'
        }
      >
        <IonCol className="login-form">
          <div className="login-logo-container ion-padding-bottom">
            <BeaconLogo className="login-logo" />
          </div>
          {props.children}
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export { LoginWrapper };
